<template>
  <section id="article" v-if="article">
    <cover-image
      :src="(article.shouldShowCover && article.image) ? article.image : '/static/placeholders/placeholder-logo.jpg'"
      :title="''"
      :description="''"
      :type="'medium'"
    />
    <article class="article container" :class="article.image == null ? 'no-image' : ''">
      <h4
        v-if="article.author"
        class="author text-center"
      >{{ article.author.name + ' ' + article.author.surname }}</h4>
      <h1 class="title row text-center">{{ translation.title }}</h1>
      <p class="date row text-center">{{ formatDate(article.publishDate, 'en') }}</p>

      <div class="article-options">
        <i v-on:click="print" class="fa fa-print article-option"></i>
        <social-sharing
          :url="'http://mons.rs' + this.$route.path"
          :title="translation.title"
          :description="translation.description"
          :hashtags="'mons'"
          inline-template
        >
          <span>
            <network class="article-option" network="facebook">
              <i class="fa fa-facebook"></i>
            </network>
            <network class="article-option" network="twitter">
              <i class="fa fa-twitter"></i>
            </network>
          </span>
        </social-sharing>
      </div>

      <div class="separator"></div>
      <div name="content" class="content row" ref="content" v-html="translation.content"></div>
      <graph-view :chartData="chartData" :chartOptions="chartOptions" v-if="graphExists" />
      <maps-view :chartData="chartData" :chartOptions="chartOptions" v-if="mapExists" />

      <div class="row" v-if="article && (article.previousArticle || article.nextArticle )">
        <div v-if="hasPreviousArticle" class="button article-nav col-4">
          <router-link :to="{name: 'articleById', params: {id: article.previousArticle}}">
            <i class="fa fa-caret-left"></i>
            {{ $t('button.previous_article') }}
          </router-link>
        </div>
        <div
          v-if="hasNextArticle"
          class="button article-nav col-4 text-right"
          :class="hasPreviousArticle ? 'push-4' : 'push-8'"
        >
          <router-link :to="{name: 'articleById', params: {id: article.nextArticle}}">
            {{ $t('button.next_article') }}
            <i class="fa fa-caret-right"></i>
          </router-link>
        </div>
      </div>

      <div id="lightbox" class="modal fade">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <img src alt id="lightbox-image" class="modal-image" />
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import CoverImage from '@/components/ui/CoverImage'
import ArticlesService from '@/services/ArticlesService'

import { GraphView, MapsView } from '../ui'

export default {
  name: 'ArticleView',
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { property: 'og:type', content: 'article' },
        {
          property: 'og:url',
          content: 'http://mons.rs' + this.$route.fullPath
        },
        { property: 'og:title', content: this.title },
        {
          property: 'og:description',
          content: this.translation != null ? this.translation.description : ''
        },
        {
          property: 'og:image',
          content:
            this.article != null
              ? this.article.image
              : this.$route + '/static/placeholders/placeholder-logo.jpg'
        }
      ]
    }
  },
  components: {
    CoverImage,
    GraphView,
    MapsView
  },
  props: {
    language: String,
    fromId: Boolean
  },
  computed: {
    translation: function() {
      if (this.article == null) {
        return null
      }

      return this.article.articleTranslations[0]
    },
    chartOptions: function() {
      return JSON.parse(this.translation.chartOptions)
    },
    chartData: function() {
      return JSON.parse(this.translation.chartData)
    },
    graphExists: function() {
      if (this.chartOptions && this.chartData) {
        if (this.chartOptions.chart.type !== 'map') {
          return true
        }
      }
      return false
    },
    hasPreviousArticle: function() {
      return this.article.previousArticle
    },
    hasNextArticle: function() {
      return this.article.nextArticle
    },
    mapExists: function() {
      if (this.chartOptions && this.chartData) {
        if (this.chartOptions.chart.type === 'map') {
          return true
        }
      }
      return false
    }
  },
  data() {
    return {
      article: null,
      title: ''
    }
  },
  created: function() {
    if (this.translation !== null && this.translation.slug === ' ') {
      this.getArticleForId(this.article.id)
    } else {
      this.getArticle()
    }
  },
  watch: {
    language: function() {
      this.getArticleForId(this.article.id)
      // this.$emit('languageChanged', this.language)
    },
    article: function() {
      this.title = this.translation.title
      this.$emit('languageChanged', this.translation.language)
    },
    $route: function() {
      this.getArticle()
    }
  },
  methods: {
    getArticle: function() {
      const slug = this.$route.params.slug
      ArticlesService.get(slug).then(
        response => {
          this.article = response.body
          if (new Date(this.article.publishDate).getTime() > new Date().getTime()) {
            // this.$router.replace('/')
          }
          this.setupContent()
        },
        response => {
          console.error(response.body)
        }
      )
    },
    getArticleForId: function(id) {
      ArticlesService.getForId(id).then(
        response => {
          this.article = response.body
          if (this.translation !== null && this.translation.slug !== ' ') {
            this.$router.replace({
              name: 'article',
              params: { slug: this.translation.slug }
            })
          }
          if (new Date(this.article.publishDate).getTime() > new Date().getTime()) {
            // this.$router.replace('/')
          }
          this.setupContent()
        },
        response => {
          console.error(response.body)
        }
      )
    },
    setupContent: function() {
      if (this.$refs.content === null || this.$refs.content === undefined) {
        return
      }
    },

    print: function() {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/_vars.scss';

#article {
  background: $white;
}

.article {
  padding: 2rem 1rem;

  .title {
    color: $txt-color-heading;
    font-weight: $bold;
    display: block;
  }

  .subtitle {
    color: $txt-color-primary;
    font-size: 1.25rem;
    line-height: 1.5;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .author {
    font-size: 1.25rem;
    font-weight: $semibold;
    margin-bottom: 0.5rem;
    color: $txt-color-secondary;
  }
}

.content,
.date {
  display: block;
  margin: 1rem 0;
}

.date {
  color: $txt-color-secondary;
  letter-spacing: $letter-spacing-date;
  text-transform: uppercase;
  font-weight: $semibold;
  font-size: 0.75rem;
}

.separator {
  display: block;
  width: 2rem;
  height: 0.25rem;
  border-radius: $border-radius-standard;
  background: $secondary-color;
  margin: 2rem auto;
}

.content {
  color: $txt-color-primary;
  * {
    display: block;
  }
}

.article-nav {
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: $semibold;
  font-size: 0.75rem;
  margin: 1rem 0;

  a {
    color: $primary-color;
    transition: all 150ms;
    padding: 0.75rem 1.5rem;
    background: white;
    border-radius: $border-radius-standard;
    box-shadow: $drop-shadow-card;

    &:hover {
      background: $secondary-color;
      color: $white;
      text-decoration: none;
    }
  }
}
</style>

<style lang="scss">
@media print {
  .cover-image,
  #navigation,
  .article-options {
    display: none;
  }

  .article {
    overflow: visible;
    .title {
      font-size: 2rem;
      line-height: 1;
    }
    .content {
      font-size: 1rem;
    }
  }
}
</style>

<style lang="scss">
@import '~styles/_vars.scss';
.article {
  img {
    display: block;
    max-width: 60%;
    margin: 3rem auto;
    @media (max-width: $device-sm) {
      display: block;
      max-width: 100%;
    }

    &.image-map {
      max-width: 100%;
      margin: 2rem auto;
    }

    &.modal-image {
      margin: 0 auto;
      max-width: 100%;
    }
  }

  #lightbox {
    .modal-dialog {
      max-width: 50%;
    }
  }

  .content {
    h2 {
      margin: 4rem 0 2rem;
    }

    h3 {
      margin: 2rem 0 1rem 0;
    }

    h4 {
      margin: 2rem 0 1rem 0;
      font-size: 1.25rem;
      font-weight: bold;
      > .ttip {
        font-weight: bold;
      }
    }

    p,
    .ttip {
      line-height: 1.8;

      @media (max-width: $device-sm) {
        line-height: 1.6;
      }
    }

    .source {
      text-align: center;
      font-size: 0.8rem;
      font-weight: $semibold;
      margin: 0;
      padding: 0;
    }
  }

  .article-options {
    text-align: center;
    font-size: 1.5rem;

    .article-option {
      margin-right: 0.5rem;
      cursor: pointer;
      transition: all 150ms;

      &.fa-print:hover {
        color: lighten($txt-color-primary, 15%);
      }

      .fa {
        transition: all 150ms;
      }

      .fa-facebook {
        color: $facebook;
        &:hover {
          color: lighten($facebook, 10%);
        }
      }

      .fa-twitter {
        color: $twitter;
        &:hover {
          color: lighten($twitter, 10%);
        }
      }
    }
  }
}

.double-img {
  text-align: center;

  img {
    display: inline-block;
    max-width: 45%;
    margin: 2rem 1rem 2rem 0;
    @media (max-width: $device-sm) {
      display: block;
      max-width: 100%;
    }
  }
}

.blockquote {
  font-size: 0.85rem;
}

// Social media
.fb-share-button,
.twitter-share-button {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// ArticleView.vue?7b76d4fe